export default __webpack_public_path__ + "static/media/SC REWARDS MOBILE BANNER 800 x 300 px.3ea986e1.png";